<template>
  <div>
    <el-tooltip :content="$t('reportingProfiles.edit.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true">
        <span class="mdi mdi_icon mdi-24px mdi-pencil-outline"/>
      </base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="card-title d-inline">{{ $t('reportingProfiles.edit.titleText') }}</h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('reportingProfiles.edit.helpText') }}</small>
        </div>
        <form role="form" v-on:submit.prevent="create()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.label') }}</label>
            <div class="col-md-9">
              <base-input
                name="label"
                :error="getError('label')"
                v-model="profile.label"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.contact_name') }}</label>
            <div class="col-md-9">
              <base-input
                name="name"
                v-validate="modelValidations.required"
                :error="getError('contact_name')"
                v-model="profile.contact_name"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.contact_surname') }}</label>
            <div class="col-md-9">
              <base-input
                name="surname"
                v-validate="modelValidations.required"
                :error="getError('surname')"
                v-model="profile.contact_surname"
              >
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('reportingProfiles.details.email') }}</label>
            <div class="col-md-9">
              <base-input
                type="email"
                name="email"
                v-validate="modelValidations.email"
                :error="getError('email')"
                v-model="profile.email"
              >
              </base-input>
            </div>
          </div>
          <base-alert v-if="error" type="danger">
            <!-- TODO: add error translation -->
            {{ error }}
          </base-alert>

          <div class="text-center">
            <base-button
              type="primary"
              class="my-4"
              @click="validate()"
            >{{ $t('reportingProfiles.edit.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'create-reporting-profile',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    formDetails: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      modal: false,
      alert: false,
      profile: {...this.formDetails},
      modelValidations: {
        required: {
          required: true
        },
        email: {
          email: true,
          required: true
        },
        number: {
          numeric: true
        },
        url: {
          url: true
        },
        equalToSource: {
          required: true
        },
        equalToDest: {
          required: true,
          confirmed: 'equalToSource'
        }
      }
    }
  },
  computed: {
    ...mapState({
      error: state => state.reporting_profile.error,
    }),
  },
  methods: {
    ...mapActions(['UpdateReportingProfile', 'ResetReportingProfileError']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        // this.$emit('on-submit', this.registerForm, isValid);
        if (isValid) {
          this.update(this.profile)
        }
      });
    },
    update(profile) {
      // alert('Your data: ' + JSON.stringify(this.updated));

      this.UpdateReportingProfile(profile).then(() => {
        if (this.error !== null) {
          this.$notify({
            type: 'danger',
            message: `${this.error}`,
            icon: 'tim-icons icon-alert-circle-exc'
          })
        } else {
          this.$notify({
            type: 'success',
            message: `${this.$t('reportingProfiles.profileUpdated')}`,
            icon: 'tim-icons icon-alert-circle-exc'
          })
          // Close modal
          this.resetForm()
        }
      })
    },
    resetForm: function () {
      // closing dialog
      this.modal = false

      this.profile = {...this.formDetails}
      this.ResetReportingProfileError()

      // reset validation errors
      this.$validator.reset()
    },
  }
}
</script>
